export const TOGGLE_NAVIGATION_BAR = 'TOGGLE_NAVIGATION_BAR';

export const FETCH_NEWSLETTER_REQUEST = 'FETCH_NEWSLETTER_REQUEST';
export const FETCH_NEWSLETTER_SUCCESS = 'FETCH_NEWSLETTER_SUCCESS';
export const FETCH_NEWSLETTER_FAILURE = 'FETCH_NEWSLETTER_FAILURE';

export const SET_NAVIGATION_ROLE = 'SET_NAVIGATION_ROLE';

export const SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES';
